import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PROFILE_DATA_SERVICE, ProfileDataService } from '../../../../services/profile/profile-data.service';
import { UserProfileShareService } from '../../../../services/shared-service/user-profile-share.service';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from '../../../../services/resources/resources-data.service';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { Store } from '@ngxs/store';
import { CLOUD_DATA_SERVICE, CloudDataService } from '../../../../services/cloud/cloud-data.service';
import { AdminMandant, Area, Employee, OrgUnitSetting } from '../../../../models/cloud/cloud.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { HideLoader, ShowLoader } from '../../../store/loader/loader.actions';
import { ActionHelper } from '../../../../helper/action.helper';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'fi-areas',
    templateUrl: './areas.component.html',
    styleUrls: ['./areas.component.scss'],
  standalone: false,
})
export class AreasComponent implements OnInit, OnChanges {
    @Input() mandant?: AdminMandant;
    areas: Area[] = [];
    edittedArea? :Area;
    edditedIndex = -1;
    employees: Employee[];
    selectedUsers: Employee[];
    selectedUsersText = '';

    numberError = false;
    descriptionError = false;

    constructor(
        private readonly sharedProfileService: UserProfileShareService,
        @Inject(PROFILE_DATA_SERVICE) private readonly profileDataService: ProfileDataService,
        @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
        @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
        @Inject(RESOURCES_DATA_SERVICE) private resourcesDataService: ResourcesDataService,
        @Inject(ACTION_DATA_SERVICE) public actionDataService: ActionDataService,
        @Inject(CLOUD_DATA_SERVICE) public cloudDataService: CloudDataService,
        private dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private store: Store
    ) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.mandant?.currentValue) {
            this.getAreas();
            this.cloudDataService.getEmployees(this.mandant.Id).subscribe(({success, data}) => {
                this.employees = data?.filter(x => x.Appplications.find(app=> app.Name === 'FINSTRALContacts')) ?? [];
                this.employees.forEach(x => {
                    x.Id = x.User.Id;
                    x.FullName = `${x.User.FirstName} ${x.User.LastName}`;
                })
            })
        }
    }

    getAreas(): void {
        this.cloudDataService.getAreas(this.mandant.Id).subscribe(({success, data}) => {
            if (data) {
                this.areas = data
            }
        })
    }

    onEdit(idx: number): void {
        const area = this.areas[idx];
        this.edditedIndex = idx;

        this.edittedArea = {
            ...area,
            AssignedUsers: [...area.AssignedUsers],
        }

        this.selectedUsers = area.AssignedUsers
            .map((id) => this.employees.find(x => x.Id === id)).filter(x => x);

        this.updateSelectionTexts();
        this.numberError = this.descriptionError = false;
    }

    onCreate(): void {
        this.edditedIndex = -1;
        this.selectedUsers = [];

        this.edittedArea = {
            Description: '',
            MandantId: this.mandant.Id,
            Number: undefined,
            Inactive: false,
            AssignedUsers: [],
        };

        this.updateSelectionTexts();
        this.numberError = this.descriptionError = false;
    }

    onDelete(i: number, askForConfirmation = true): void {
        const deleteArea = () => {
            this.store.dispatch(new ShowLoader());
            this.cloudDataService.deleteArea(this.mandant.Id, this.areas[i].Number).subscribe(({success}) => {
                if (success) {
                    this.getAreas();
                }

                this.edittedArea = null;
                this.store.dispatch(new HideLoader());
            })
        }

        if (askForConfirmation) {
            ActionHelper.showAction('DELETE-CONFIRM', this.dialog, {
                customMessageSnippet: 'ADMINISTRATION_AREA_MESSAGE_DELETION',
                customConfirmSnippet: 'ADMINISTRATION_BUTTON_CONFIRM',
                customCancelSnippet: 'ADMINISTRATION_BUTTON_CANCEL',
            })?.afterClosed().subscribe(data => {
                if (data) {
                    deleteArea();
                }
            });
        } else {
            deleteArea();
        }
    }

    onSubmit(): void {
        if (!Number.isInteger(this.edittedArea.Number) || this.edittedArea.Number < 0 || this.edittedArea.Number > 9999) {
            this.numberError = true;
        }

        if (!this.edittedArea.Description?.trim()) {
            this.descriptionError = true;
        }

        if (this.numberError || this.descriptionError) {
            return;
        }

        this.store.dispatch(new ShowLoader());
        this.cloudDataService.saveArea(this.edittedArea).subscribe(({success}) => {
            if (success) {
                if (this.edditedIndex >= 0 && this.areas[this.edditedIndex].Number !== this.edittedArea.Number) {
                    this.onDelete(this.edditedIndex, false);
                } else {
                    this.getAreas();
                    this.edittedArea = null;
                    this.store.dispatch(new HideLoader());
                }
            } else {
                this.store.dispatch(new HideLoader());
            }
        })
    }

    updateSelectionTexts(): void {
        this.selectedUsersText = this.selectedUsers.map(x => x.FullName).join(', ');
    }

    onUsersChanged(value: string[]): void {
        this.selectedUsers = this.employees.filter(x => value.includes(`${x.Id}`));
        this.edittedArea.AssignedUsers = this.selectedUsers.map(x => x.Id);
        this.updateSelectionTexts();
    }

    back(): void {
        if (this.edittedArea) {
            this.edittedArea = null;
            return
        }
    }

    onClearUsers(): void {
        this.selectedUsers = [];
        this.edittedArea.AssignedUsers = [];
        this.updateSelectionTexts();
    }
}
